import React, { useState } from "react";
import ModeSelector from "./ModeSelector";
import ZipForm from "./ZipForm";
import ZipDataTable from "./ZipDataTable";
import CapExInputsForm from "./CapExInputsForm";
import SubmitForm from "./SubmitForm";
import MultiPageInputsForm from "./MultiPageInputsForm";
import ProgressBar from './ProgressBar';
import { TabsContainerStyled } from "../styles/Form";
import ZipDataTableMobile from "./ZipDataTableMobile";

const Home = ({ user, formStep, setFormStep, setResults, isMobile }) => {
  const [mode, setMode] = useState("zip"); // "zip" or "manual"
  const [zipCodes, setZipCodes] = useState([]);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState([]);

  const checkForErrors = () => {
    let newErrors = []
    let firstProperty = {...formData[Object.keys(formData)[0]]}
    Object.keys(firstProperty).forEach((key) => {
      if(firstProperty[key]['validation']['max'] && (firstProperty[key]['value'] > firstProperty[key]['validation']['max'])) {
        newErrors.push({ 'input': key, 'message': `${firstProperty[key]['displayName']} value entered is greater than the max value of ${firstProperty[key]['validation']['max']}.` })
      }
      else if(firstProperty[key]['validation']['min'] && (firstProperty[key]['value'] < firstProperty[key]['validation']['min'])) {
        newErrors.push({ 'input': key, 'message': `${firstProperty[key]['displayName']} value entered is less than the min value of ${firstProperty[key]['validation']['min']}.` })
      }
    })
    setErrors(newErrors);
    if (newErrors.length > 0) {return false} else {return true}
  }

  const handleIncrementFormStep = () => {
    if(((mode==='manual' && formStep > 0) || (mode==='zip' && formStep >= 1)) && checkForErrors()) {
      let newformStep = formStep
      setFormStep(newformStep + 1)
      window.scrollTo({top: 0, behavior: 'smooth'});
    } 
    else if(formStep === 0) {
      let newformStep = formStep
      setFormStep(newformStep + 1)
      setErrors([]);
      window.scrollTo({top: 0, behavior: 'smooth'});
    } else {
      window.scrollTo({top: document.body.scrollHeight, behavior: 'smooth'});
    }
  }

  const handleDecrementFormStep = () => {
    setErrors([])
    let newformStep = formStep
    setFormStep(newformStep - 1)
    window.scrollTo({top: 0, behavior: 'smooth'});
  }

  return (
    <TabsContainerStyled>
      <ProgressBar step={formStep} totalSteps={mode==='manual'?6:7}/>
      {
        formStep === 0 ? 
        <ModeSelector 
          mode={mode} 
          setMode={setMode} 
          setFormData={setFormData}
          handleIncrementFormStep={handleIncrementFormStep}
        /> :

        (formStep === 1 && mode === 'zip') ? 
          <ZipForm 
            mode={mode}
            handleIncrementFormStep={handleIncrementFormStep} 
            handleDecrementFormStep={handleDecrementFormStep} 
            zipCodes={zipCodes}
            setZipCodes={setZipCodes}
            formData={formData}
            setFormData={setFormData}
            user={user}
          /> :
        (formStep === 1 && mode === 'manual') ?
        
        <MultiPageInputsForm
          mode={mode}
          handleIncrementFormStep={handleIncrementFormStep}
          handleDecrementFormStep={handleDecrementFormStep}
          formData={formData}
          setFormData={setFormData}
          inputType={'property_details'}
          isMobile={isMobile}
          errors={errors}
        />:

        (formStep === 2 && mode === 'zip') ? 
        <>{
          isMobile?
          <ZipDataTableMobile
            mode={mode}
            handleIncrementFormStep={handleIncrementFormStep}
            handleDecrementFormStep={handleDecrementFormStep}
            zipCodes={zipCodes}
            formData={formData}
            setFormData={setFormData}
            errors={errors}
          />:
          <ZipDataTable 
            mode={mode}
            handleIncrementFormStep={handleIncrementFormStep}
            handleDecrementFormStep={handleDecrementFormStep}
            zipCodes={zipCodes}
            formData={formData}
            setFormData={setFormData}
            errors={errors}
          /> 
        }</>:

        (formStep === 3 && mode === 'zip') || (formStep === 2 && mode === 'manual') ?

        <MultiPageInputsForm
          mode={mode}
          formStep={formStep}
          handleIncrementFormStep={handleIncrementFormStep}
          handleDecrementFormStep={handleDecrementFormStep}
          formData={formData}
          setFormData={setFormData}
          inputType={'loan_details'}
          isMobile={isMobile}
          errors={errors}
        />:

        (formStep === 4 && mode === 'zip') || (formStep === 3 && mode === 'manual') ?

        <MultiPageInputsForm
          mode={mode}
          formStep={formStep}
          handleIncrementFormStep={handleIncrementFormStep}
          handleDecrementFormStep={handleDecrementFormStep}
          formData={formData}
          setFormData={setFormData}
          inputType={'operating_expenses'}
          isMobile={isMobile}
          errors={errors}
        />:

        (formStep === 5 && mode === 'zip') || (formStep === 4 && mode === 'manual') ?

        <MultiPageInputsForm
          mode={mode}
          formStep={formStep}
          handleIncrementFormStep={handleIncrementFormStep}
          handleDecrementFormStep={handleDecrementFormStep}
          formData={formData}
          setFormData={setFormData}
          inputType={'market_details'}
          isMobile={isMobile}
          errors={errors}
        />:

        (formStep === 6 && mode === 'zip') || (formStep === 5 && mode === 'manual') ?

        <CapExInputsForm
          handleIncrementFormStep={handleIncrementFormStep}
          handleDecrementFormStep={handleDecrementFormStep}
          formData={formData}
          setFormData={setFormData}
          isMobile={isMobile}
          errors={errors}
        />:

        <SubmitForm
          mode={mode}
          handleDecrementFormStep={handleDecrementFormStep}
          formData={formData}
          zipCodes={zipCodes}
          setResults={setResults}
        />
      }
    </TabsContainerStyled>
  );
};


export default Home;